import "../base/_jquery-global";

export default function customInit() {
    $(".cd-morph-dropdown .dropdown a").click(function () {
        $(".nav-links").removeClass("active");
        $(".cd-morph-dropdown").removeClass("is-dropdown-visible");
    });

    $(".cd-morph-dropdown .dropdown a").click(function () {
        $(".cd-morph-dropdown").removeClass("nav-open");
    });

    $(".cd-main-content .contact-form select").change(function () {
        $(this).css("color", "#492F24");
    });

    // Changes color on hover
    $(function () {
        $("select").hover(
            function () {
                $(this).addClass("hovered");
            },
            function () {
                $(this).removeClass("hovered");
            }
        );
    });

    $(document).ready(function () {
        // Index sport-specific booster clubs carousel
        $("#static-carousel-cutout").slick({
            arrows: false,
            autoplay: true,
            dots: false,
            draggable: false,
            swipe: false,
            pauseOnHover: false,
            cssEase: "ease",
            accessibility: true,
            autoplaySpeed: 5000,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 2200,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1441,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        $("#static-carousel-full").slick({
            arrows: false,
            autoplay: true,
            dots: false,
            draggable: false,
            swipe: false,
            pauseOnHover: false,
            cssEase: "ease",
            accessibility: true,
            autoplaySpeed: 5000,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 2200,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1441,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        // First slideshow triggers the other two to change
        $("#static-carousel-cutout").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            $("#static-carousel-full").slick("slickNext");
        });
    });

    // Nav effect on scroll for interior pages
    function interiorNavScroll() {
        const body = document.querySelector("body");
        const nav = document.querySelector(".cd-morph-dropdown");
        const logoTop = document.querySelector("#interior-logo-top");

        if (body.getAttribute("id") === "w-club") {
            nav.classList.add("fixed-top", "bg-secondary", "bg-secondary-texture", "shadow");
            logoTop.classList.add("mt-6");
            logoTop.querySelector("#cowboy-joe-club-text").classList.add("text-secondary");
        }

        if (body.classList.contains("interior-page") && body.getAttribute("id") !== "w-club") {
            document.addEventListener("scroll", () => {
                if (window.scrollY > 20) {
                    nav.classList.add("fixed-top", "bg-secondary", "bg-secondary-texture", "shadow");
                } else {
                    nav.classList.remove("fixed-top", "bg-secondary", "bg-secondary-texture", "shadow");
                }
            });
        }
    }

    interiorNavScroll();
}
